export default "/images/vendor/flag-icon-css/flags/4x3/nc.svg?5681de45e8340741e312252970a01037";